export default "__VITE_ASSET__ec42fcdb__"